<template>
  <v-autocomplete
    v-model="selectedValue"
    :items="getStatusList"
    :multiple="multiple"
    :search-input.sync="search"
    :item-text="'title'"
    :item-value="'id'"
    label="Выберите статус"
    return-object
    dense
    outlined
    hide-details
    @input="onInputChange"
    @change="onValueChange"
  />
</template>

<script>
import PaymentReceiptApiMixin from '@/mixins/paymentReceiptApiMixin'

export default {
  name: 'PaymentReceiptStatusFilter',
  mixins: [PaymentReceiptApiMixin],
  props: {
    value: {
      type: [Object, Array],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedValue: this.value,
      search: '',
    }
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          this.selectedValue = newValue
        }
      },
    },
  },
  methods: {
    onInputChange (value) {
      this.$emit('input', value)
    },
    onValueChange (value) {
      this.$emit('onPaymentReceiptStatusFilterChanged', value)
    },
    onClear () {
      this.selectedValue = null
      this.search = ''
      this.$emit('onPaymentReceiptStatusFilterChanged', this.selectedValue)
    },
  },
}
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
